export enum SignalREventEnum {
  UserJoined = 'user-joined',
  UserLeft = 'user-left',
  CallPeer = 'call-peer',
  MessageGroup = 'message-group',
  GoLive = 'go-live',
  RequestControl = 'request-control',
  UpdateConnectedPeers = 'update-connected-peers',
  UpdateEncoder = 'update-encoder',
  UpdateStream = 'update-stream',
  UpdateProject = 'update-project',
  UpdateIsAwaitingApiSaveToComplete = 'update-is-awaiting-api-save-to-complete',
}

export type SignalREvent =
  | SignalREventEnum.UserJoined
  | SignalREventEnum.UserLeft
  | SignalREventEnum.UserLeft
  | SignalREventEnum.CallPeer
  | SignalREventEnum.MessageGroup
  | SignalREventEnum.GoLive
  | SignalREventEnum.RequestControl
  | SignalREventEnum.UpdateConnectedPeers
  | SignalREventEnum.UpdateEncoder
  | SignalREventEnum.UpdateStream
  | SignalREventEnum.UpdateProject
  | SignalREventEnum.UpdateIsAwaitingApiSaveToComplete;
